import { graphql, compose } from 'react-apollo'
import { groupBy, keys } from 'ramda'
import { Layout, Table, Button, Modal, Input, message, Popconfirm } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import XLSX from 'xlsx'


import createBatchTrackingFlashMutation from '../graphql/mutations/CreateBatchTrackingFlash'
import updateBatchTrackingFlashMutation from '../graphql/mutations/UpdateBatchTrackingFlash'
import deleteBatchTrackingFlashMutation from '../graphql/mutations/DeleteBatchTrackingFlash'
import editLabelAddressMutation from '../graphql/mutations/editLabelAddress'
import hookTrackingMutation from '../graphql/mutations/hookTracking'


import Footer from '../components/Footer'
import inboxLabel from '../helpers/inbox'
import labelsQuery from '../graphql/queries/labels'
import Navbar from '../components/Navbar'
import raceLabel from '../helpers/race_flash'
import shopLabel from '../helpers/shop_flash'

import '../css/table.css'

const { Content } = Layout
const { TextArea } = Input;

const getReference = (label) => {
  switch (label.app) {
    case 'shop': return label.referenceId
    case 'race': return label.data.bibs.join(', ')
    case 'inbox': return label.referenceId
    default: return '-'
  }
}

const labelMapper = {
  shop: shopLabel,
  race: raceLabel,
  inbox: inboxLabel,
}

class FlashLabel extends Component {
  state = {
    selectedRowKeys: [],
    filteredRows: [],
    selectedLabels: [],
    filters: {},
    visibleModalEditAddress: false,
    labelIdEditAddress : '',
    editAddressDetail : '',
    editPhoneDetail: '',
    editNameDetail:'',
    searchKey: '',
    loadingApi: false,
    loadingHooks: false,
  }

  async componentDidMount() {
    const { group } = this.props.match.params
    await this.props.labels.refetch({ group })
    this.onTableChange(null, {})
  }
  onSelectChange = (selectedRowKeys) => {
    const { labels: { labels = [] } } = this.props
    this.setState({
      selectedRowKeys,
      selectedLabels: labels.filter(label => selectedRowKeys.includes(label._id)),
    })
  }

  onTableChange = (pagination, filters, sorter) => {
    const { labels: { labels = [] } } = this.props
    this.setState({ filters })
    const filtersFunc = (label) => {
      const filterStatus =   (filters.status && filters.status.length > 0 ? filters.status.includes(this.checkStatus(label)) : true)
      const filterTracking = (filters.tracking ? filters.tracking.includes(this.checkHasTracking(label)) : true)
      const filterSendNoti = (filters.sendHook && filters.sendHook.length > 0 ? filters.sendHook.includes(this.checkSendNoti(label)) : true)
      return filterStatus && filterTracking && filterSendNoti
    }
    this.setState({
      filteredRows: labels.filter(filtersFunc),
      selectedRowKeys: [],
    })
  }

  checkSendNoti = (label) => {
    if (label.tracking) {
      return (label.tracking.sendHook ? 'send' : 'waiting')
    }
    return '-'
  }

  checkStatus = (label) => {
    if (label.tracking) {
      return label.tracking.status
    }
    return '-'
  }

  checkHasTracking= (label) => {
    if (label.tracking) {
      return 'has'
    }else{
      return 'empty'
    }
  }

  createFlashTracking = async () => {
      this.setState({ loadingApi: true })
      const { selectedLabels } = this.state
      
      const labelIds = selectedLabels.filter(({ tracking }) => tracking === null).map(({ ...label }) => label._id)
      const response = await this.props.createBatchTrackingFlash({ variables: {labelIds} })
      const responseData = response.data.createBatchTrackingFlash

      let successCount = 0
      let failCount = 0
      let addressErrorCount = 0
      let otherErrorCount = 0

      responseData.forEach((record) => {
        if(record._id === 'address_error'){
            addressErrorCount++
            failCount++
        }else if(record._id === 'error'){
            otherErrorCount++
            failCount++
        }else{
            successCount++
        }
      })

      this.setState({ loadingApi: false })

      alert('Create Tracking Completed \n Success : ' + successCount + '\n Error : ' + failCount+ '\n - Address Error : ' + addressErrorCount+ '\n - Other Error : ' + otherErrorCount)
      window.location.reload();

  }

  updateFlashTracking = async () => {
    this.setState({ loadingApi: true })
    const { selectedLabels } = this.state
    
    const labelIds = selectedLabels.filter(({ tracking }) => tracking !== null && tracking.status !== 'Delete').map(({ ...label }) => label._id)
    const response = await this.props.updateBatchTrackingFlash({ variables: {labelIds} })
    const responseData = response.data.updateBatchTrackingFlash

    let successCount = 0
    let failCount = 0

    responseData.forEach((record) => {
      if(record._id === 'error'){
          failCount++
      }else{
        successCount++
      }
    })

    this.setState({ loadingApi: false })

    alert('Update Tracking Completed \n Success : ' + successCount + '\n Error : ' + failCount)
    window.location.reload();

  }

  deleteFlashTracking = async () => {
    this.setState({ loadingApi: true })
    const { selectedLabels } = this.state
    
    const labelIds = selectedLabels.filter(({ tracking }) => tracking !== null).map(({ ...label }) => label._id)
    const response = await this.props.deleteBatchTrackingFlash({ variables: {labelIds} })
    const responseData = response.data.deleteBatchTrackingFlash

    let successCount = 0
    let failCount = 0

    responseData.forEach((record) => {
      if(record._id === 'error'){
          failCount++
      }else{
        successCount++
      }
    })

    this.setState({ loadingApi: false })

    alert('Delete Tracking Completed \n Success : ' + successCount + '\n Error : ' + failCount)
    window.location.reload();

}

  sendTrackingNoti = async () => {

    this.setState({ loadingHooks: true })
    const { selectedLabels } = this.state
    const labelsPromise = selectedLabels.filter(({ tracking }) => !!tracking && tracking.status !== 'Delete').map(({ tracking, ...label }) => this.props.hookTracking({ variables: { labelId: label._id, trackingId: tracking._id } }))
    
    await Promise.all(labelsPromise)
    alert( 'Send Notification Complete' )
    this.setState({ loadingHooks: false })

  }

  printLabel = async () => {
    const { selectedLabels } = this.state
    const groupedLabels = groupBy(label => label.app, selectedLabels.filter(({ tracking }) => tracking !== null && tracking.status !== 'Delete'))
    const groups = keys(groupedLabels)
    groups.asyncForEach((group) => {
      const labels = groupedLabels[group]
      const html = labelMapper[group].genLabel(labels)
      const wnd = window.open('Label Flash', '')
      wnd.document.write(html)
      wnd.document.close()
    })
  }

  exportExcel = async () => {
    var { selectedLabels } = this.state
    selectedLabels = selectedLabels.filter(({ tracking }) => tracking === null || tracking.status !== 'Delete')
    const excelData = selectedLabels.map((label) => {
      const items = label.data.items ? label.data.items.map(item => `[${item.amount}] ${item.name}`) : []
      const shirts = label.data.shirts ? label.data.shirts.map(shirt => `[1] ${shirt}`) : []
      
      if(label.tracking === null || label.tracking.status !== 'Delete'){
        return {
          'Tracking type': label.tracking ? label.tracking.carrier : '',
          'Tracking code': label.tracking ? label.tracking.code : '',
          'Label ID': label._id,
          Reference: getReference(label),
          Recipient: label.recipient.replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
          Address: label.address.replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
          Phone: label.data.phones.join(', '),
          Items: [...items, ...shirts].join(',\n'),
          Scaned: label.tracking ? moment(label.tracking.scannedAt).format('YYYY-MM-DD HH:mm:SS') : '',
          Count: label.data.count,
          Email: label.data.emails ? label.data.emails[0] : '',
          Status: label.tracking ? label.tracking.status : '',
        }
      }else{
        return ''
      }
    })
    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(excelData)
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
    XLSX.writeFile(workbook, `labels-${moment().format('YYYYMMDDHHmmSS')}.xlsx`)
  }

  // control Modal
  showEditAddress(record){
    this.setState({
      visibleModalEditAddress: true,
      labelIdEditAddress : record._id,
      editAddressDetail: record.address,
      editPhoneDetail: record.data.phones[0],
      editNameDetail: record.recipient
    });
  }

  handleCancelEditAddress = () => {
    this.setState({
      visibleModalEditAddress: false,
      labelIdEditAddress : '',
      editAddressDetail: '',
      editPhoneDetail:'',
      editNameDetail:'',
    });
  };

   handleSubmitEditAddress = async () => {
    const addressEdit = this.state.editAddressDetail
    const phoneEdit = this.state.editPhoneDetail
    const nameEdit = this.state.editNameDetail
    const labelId = this.state.labelIdEditAddress
    await this.props.editLabelAddress({ variables: { labelId: labelId, addressEdit: addressEdit, phoneEdit: phoneEdit, nameEdit: nameEdit} })
    this.setState({
      visibleModalEditAddress: false,
    });
  };

  changeValueAddress = (e) => {
    const { target: { value: addressEdited } } = e
    this.setState({
      editAddressDetail: addressEdited,
    })
  }

  changeValuePhone = (e) => {
    const { target: { value: phoneEdited } } = e
    this.setState({
      editPhoneDetail: phoneEdited,
    })
  }

  changeValueName = (e) => {
    const { target: { value: nameEdited } } = e
    this.setState({
      editNameDetail: nameEdited,
    })
  }
  // end Modal

  cancelDelete = (e) => {
    message.error('Cancel Delete');
  }

  render() {

    const { group } = this.props.match.params

    let app = ''
    const searchKey = this.state.searchKey.toLowerCase()
    let { labels: { loading, labels = [] } } = this.props
    const { selectedRowKeys, filteredRows } = this.state
    const { loadingApi, loadingHooks } = this.state
    labels.map( label => app = label.app )

    if(searchKey !== ''){
      if(app === 'race'){
        labels = labels.filter(({ data }) => data.bibs.includes(searchKey))    
      }else if(app === 'shop'){
        labels = labels.filter(({ referenceId }) => referenceId.includes(searchKey))    
      }
    }


    const rowSelection = {
      selectedRowKeys,
      onChange: selected => this.onSelectChange(selected),
      hideDefaultSelections: true,
      selections: [
        {
          key: 'all-data',
          text: 'Select All Data',
          onSelect: () => {
            this.setState({
              selectedRowKeys: filteredRows.map(label => label._id),
              selectedLabels: filteredRows,
            })
          },
        },
        {
          key: 'all-tracking',
          text: 'Select All Tracking',
          onSelect: () => {
            this.setState({
              selectedRowKeys: filteredRows.filter(label => !!label.tracking).map(label => label._id),
              selectedLabels: filteredRows,
            })
          },
        },
        {
          key: 'non-tracking',
          text: 'Select No Tracking',
          onSelect: () => {
            this.setState({
              selectedRowKeys: filteredRows.filter(label => label.tracking === null).map(label => label._id),
              selectedLabels: filteredRows,
            })
          },
        },
        {
          key: 'clear-selected',
          text: 'Clear selected',
          onSelect: () => {
            this.setState({
              selectedRowKeys: [],
              selectedLabels: [],
            })
          },
        },
      ],
      onSelection: this.onSelection,
    }
    const filterStatus = [{ text: 'Create', value: 'Create' },{ text: 'Update', value: 'Update'},{ text: 'Delete', value: 'Delete'} ]
    const filterTracking = [{ text: 'Tracking', value: 'has' }, { text: '-', value: 'empty' }]
    const filterSendNoti = [{ text: 'Send', value: 'send' }, { text: 'Waiting', value: 'waiting' }]

    const columns = [
      {
        title: 'Label ID',
        key: 'labelId',
        width: 100,
        className: 'text-center',
        render: record => (<span>{record._id}<br />({record.app})</span>),
      },
      {
        title: 'Reference',
        key: 'reference',
        width: 100,
        className: 'text-center',
        render: getReference,
      },
      {
        title: 'Recipient',
        dataIndex: 'recipient',
        key: 'recipient',
        width: 150,
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: 'Count',
        key: 'count',
        width: 60,
        className: 'text-center',
        render: record => record.data.count,
      },
      {
        title: 'Items',
        key: 'item',
        width: 200,
        /* eslint react/no-array-index-key: 0 */
        render: record => (
          <ul style={{ paddingLeft: '20px' }}>
            {record.data.items && record.data.items.map(item => (
              <li key={`${record.referenceId} ${item.name}`}>[{item.amount}] {item.name}</li>
            ))}
            {record.data.shirts && record.data.shirts.map((shirt, index) => (
              <li key={`${record.referenceId} ${shirt} ${index}`}>{shirt}</li>
            ))}
          </ul>
        ),
      },
      {
        title: 'Tracking',
        key: 'tracking',
        width: 100,
        className: 'text-center',
        filters: filterTracking,
        onFilter: (value, record) => this.checkHasTracking(record) === value,        
        render: record => (record.tracking ? <span>[{record.tracking.carrier}]<br />{record.tracking.code}</span> : '-'),
      },
      {
        title: 'Status',
        key: 'status',
        width: 100,
        className: 'text-center',
        filters: filterStatus,
        onFilter: (value, record) => this.checkStatus(record) === value,
        render: record => (record.tracking ? <span> {record.tracking.status} <Button type="link" onClick={ () => this.showEditAddress(record)}>แก้ไขข้อมูล</Button></span> : <Button type="link" onClick={ () => this.showEditAddress(record)}>แก้ไขข้อมูล</Button>),
      },
      {
        title: 'Send noti',
        key: 'sendHook',
        width: 80,
        className: 'text-center',
        filters: filterSendNoti,
        onFilter: (value, record) => this.checkSendNoti(record) === value,
        /* eslint no-nested-ternary: 0 */
        render: record => (record.tracking ? (record.tracking.sendHook ? 'Send' : 'Waiting') : ''),
      },
    ]
    return (
      <Layout>
        <Navbar selected="label:3" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <h2>
              Flash Labels <small>(Selected {selectedRowKeys.length} rows{keys(this.state.filters).every(key => this.state.filters[key].length === 0) ? '' : `, Filtered ${filteredRows.length} rows`})</small>
              <Button
                type="primary"
                onClick={this.sendTrackingNoti}
                disabled={this.state.selectedLabels.length === 0}
                style={{ float: 'right'}}
                loading={loadingHooks}
              >
                Send tracking
              </Button>
              <Button
                type="primary"
                onClick={this.printLabel}
                style={{ float: 'right', marginRight: '10px' }}
              >
                Print label Flash
              </Button>
              <Button
                type="primary"
                onClick={this.exportExcel}
                style={{ float: 'right', marginRight: '10px' }}
              >
                Export excel
              </Button>
            </h2>
            <p>
            <Popconfirm
                title="Are you sure to cancel this tracking?"
                onConfirm={this.deleteFlashTracking}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
            >
            <Button
                type="primary"
                disabled={this.state.selectedLabels.length === 0}
                style={{ float: 'right', backgroundColor: '#ff4e4f', borderColor: '#ff4e4f'}}
                loading={loadingApi}

              >
                Delete Tracking
            </Button>

            </Popconfirm>
            <Button
                type="primary"
                onClick={this.updateFlashTracking}
                disabled={this.state.selectedLabels.length === 0}
                style={{ float: 'right' ,marginRight: '10px'}}
                loading={loadingApi}
              >
                Update Tracking
            </Button> 
            <Button
                type="primary"
                onClick={this.createFlashTracking}
                disabled={this.state.selectedLabels.length === 0}
                style={{ float: 'right' ,marginRight: '10px' }}
                loading={loadingApi}
              >
                Create Tracking
            </Button> 
            </p><br/><br/>
            <p>
              Excel File : {group}
              <Input.Search placeholder='Search Reference' style={{ float: 'right', marginBottom: '10px', width: '250px'}} onChange={ e => this.setState({searchKey: e.target.value})} /><br />
            </p>
            <Table
              rowSelection={rowSelection}
              dataSource={labels}
              columns={columns}
              rowKey="_id"
              pagination={{ pageSize: 50 }}
              size="middle"
              onChange={this.onTableChange}
              loading={loading}
              bordered
            />
          </div>

          <Modal
          title="Edit Address"
          visible={this.state.visibleModalEditAddress}
          onOk={this.handleSubmitEditAddress}
          onCancel={this.handleCancelEditAddress}
          >
            <b>Label Id</b> : {this.state.labelIdEditAddress}<br /><br />
            <b>Recipient</b> : <Input value={this.state.editNameDetail} onChange={this.changeValueName}/><br />
            <b>Address</b> : <TextArea rows={4} value={this.state.editAddressDetail} onChange={this.changeValueAddress}/><br />
            <b>Phone</b> : <Input value={this.state.editPhoneDetail} onChange={this.changeValuePhone}/>
          </Modal>

        </Content>
        <Footer />
      </Layout>
    )
  }
}
FlashLabel.propTypes = {
  labels: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    labels: PropTypes.array,
    refetch: PropTypes.func,
  }).isRequired,
  createBatchTrackingFlash: PropTypes.func.isRequired,
  updateBatchTrackingFlash: PropTypes.func.isRequired,
  deleteBatchTrackingFlash: PropTypes.func.isRequired,
  editLabelAddress: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
}
FlashLabel.defaultProps = {}

export default compose(
  graphql(createBatchTrackingFlashMutation, { name: 'createBatchTrackingFlash' }),
  graphql(updateBatchTrackingFlashMutation, { name: 'updateBatchTrackingFlash' }),
  graphql(deleteBatchTrackingFlashMutation, { name: 'deleteBatchTrackingFlash' }),
  graphql(labelsQuery, { name: 'labels', options: { variables: { group: '' } } }),
  graphql(editLabelAddressMutation, {name: 'editLabelAddress'}),
  graphql(hookTrackingMutation, { name: 'hookTracking' }),
)(FlashLabel);


// WEBPACK FOOTER //
// ./src/pages/FlashLabel.js